import * as React from "react";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {Project} from "../../domain/model/project";
import {Entry} from "../../domain/model/entry";
import {Contract} from "../../domain/model/contract";
import {Customer} from "../../domain/model/customer";

import {createClientEntriesActionCreator} from "../action/client_entries_action";
import {
    createClientEntriesDispatcher,
    IClientEntriesDispatcher
} from "../dispatcher/client_entries_dispatcher";
import {AppState} from "../store/app_state";
import {ClientEntriesState} from "../store/client_entries_state";
import {GetAllEntriesByClientRequest} from "../request/entry_request";

import ClientEntriesComponent from "../component/client/entries/client_entries";
import {RouteComponentProps} from "react-router";

interface IProps extends RouteComponentProps<{projectId: string}>{
    state: ClientEntriesState;
    dispatcher: IClientEntriesDispatcher;

}

interface IState {
    isInit: boolean;
}

export class ClientEntries extends React.Component <IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            isInit: true,
        };

    };

    public componentDidMount() {
        const req: GetAllEntriesByClientRequest = new GetAllEntriesByClientRequest();
        req.projectId = this.props.match.params.projectId;
        this.props.dispatcher.getAllEntryList(req);
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        // init処理の終了
        const isInitFinished: boolean = this.state.isInit && !this.props.state.isLoading && prevProps.state.isLoading;
        if (isInitFinished) { return this.setState({isInit: false}) }
    }

    public render(): JSX.Element | null {

        const {state} = this.props;
        const {isInit} = this.state;

        const entries: Entry[] = state.entries;
        const customers: Customer[] = state.customers;
        const contracts: Contract[] = state.contracts;
        const project: Project | null = state.project;

        const isLoading: boolean = state.isLoading;

        return (
            <ClientEntriesComponent
                isInit={isInit}
                isLoading={isLoading}
                project={project}
                entries={entries}
                customers={customers}
                contracts={contracts}
            />
        )
    };
}


const mapStateToProps = (state: AppState) => {
    return {
        state: state.clientEntriesReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createClientEntriesDispatcher(dispatch, createClientEntriesActionCreator()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientEntries);



// WEBPACK FOOTER //
// ./src/presentation/container/client_entries_container.tsx